import dashboardSlice from '../../src/views/Dashboard/stores';
import locationSlice from '../views/Location/store';
import faqSlice from '../../src/views/Help/AddFaq/store/index';
import userSlice from '../../src/views/Setup/User/store/index';
import roleSlice from '../../src/views/Setup/RoleRights/Role/store/index';
import auditLogSlice from '../views/AuditLog/Tabs/AuditLog/store/index';
import loginLogSlice from '../views/AuditLog/Tabs/LoginLog/store/index';
import activeClosedSlice from '../views/Help/HelpDesk/store/index';
import moduleSlice from '../views/Setup/ModuleManage/store/index';
import dashboard from '../views/Dashboard/NewStore';
import screenCaptureSlice from '../views/ScreenTracker/Tabs/ScreenCapture/store/index';
import inputMonitorSlice from '../views/ScreenTracker/Tabs/InputMonitor/store/index';
import deviceUsageSlice from '../views/ScreenTracker/Tabs/DeviceUsage/store/index';
import appTimeTrackSlice from '../views/ScreenTracker/Tabs/AppTimeTracker/store/index';
import inactiveIntervalSlice from '../views/ScreenTracker/Tabs/InactiveInterval/store/index';

const crudApis = {
    dashboardSlice,
    locationSlice,
    faqSlice,
    userSlice,
    roleSlice,
    activeClosedSlice,
    moduleSlice,
    auditLogSlice,
    loginLogSlice,
    dashboard,
    screenCaptureSlice,
    inputMonitorSlice,
    deviceUsageSlice,
    appTimeTrackSlice,
    inactiveIntervalSlice
};

export default crudApis;
